import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
import LayoutVersions from "../LayoutVersions.js";
import DeleteLayoutDialog from "./DeleteLayoutDialog.js";
import RenameLayoutEditor from "./RenameLayoutEditor.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.dataViewers.layout.EditLayoutsActionCreator');
export default {
  id: 'molten.dataViewers.layout.EditLayoutsActionCreator',
  name: tf('name'),
  matches: {
    use: 'mobileLayoutActionBar'
  },
  layout: {
    sort: 'c.1'
  },
  handles: context => {
    const {
      layout
    } = context;
    if (layout == null) {
      return false;
    }
    const {
      layoutVersions,
      onLayoutDelete,
      onLayoutRename
    } = layout;
    return layoutVersions != null && (onLayoutDelete || onLayoutRename);
  },
  getActions(context) {
    const usePreferred = Config.get('UserSettingsDefaultLayoutDelegate', 'usePreferred', true);
    const allowUserPreferred = Config.get('UserSettingsDefaultLayoutDelegate', 'allowUserPreferred', true);
    const {
      layout
    } = context;
    if (layout == null) {
      return null;
    }
    const {
      layoutId,
      layoutVersions,
      onLayoutChange,
      onLayoutDelete,
      onLayoutRename
    } = layout;
    const showHeaders = layoutVersions.length > 1;
    const r = [];
    layoutVersions.forEach((vg, vgIdx) => {
      if (vg.children == null || vg.children.length === 0) {
        return;
      }
      const isUser = vg.type === 'user';
      const preferredId = vg.preferred;
      const showPreferred = usePreferred && (!isUser || allowUserPreferred);
      vg.children?.forEach((v, vIdx) => {
        const onUse = () => {
          const data = {
            group: vg,
            version: v
          };
          onLayoutChange({
            value: data?.version?.value || 'none',
            data,
            isReplace: false
          });
        };
        const onRename = () => {
          RenameLayoutEditor.show({
            layoutGroup: vg,
            layoutVersion: v,
            onLayoutRename
          });
        };
        const onDelete = () => {
          DeleteLayoutDialog.show({
            layoutGroup: vg,
            layoutVersion: v,
            onLayoutDelete
          });
        };
        const onDefault = () => {
          LayoutVersions.setPreferredLayout({
            layoutGroup: vg,
            value: preferredId === v.value ? null : v.value
          });
        };
        const sublayout = [];
        const sublayoutContext = {};
        sublayout.push({
          handles: Config.get('molten.dataViewers.layout.RenameLayoutAction', 'handles', cxt => true),
          appearance: cxt => {
            const name = t('rename');
            const icon = tIcon('edit', 'https://storage.googleapis.com/molten-ui-assets/edit.svg');
            return {
              name,
              icon
            };
          },
          perform: onRename
        });
        sublayout.push({
          handles: Config.get('molten.dataViewers.layout.DeleteLayoutAction', 'handles', cxt => true),
          appearance: cxt => {
            const name = t('delete');
            const icon = tIcon('trash', 'https://storage.googleapis.com/molten-ui-assets/trash.svg');
            return {
              name,
              icon
            };
          },
          perform: onDelete
        });
        if (showPreferred) {
          sublayout.push({
            handles: Config.get('molten.dataViewers.layout.SetLayoutAsDefaultAction', 'handles', cxt => true),
            layout: {
              sort: 'z.z'
            },
            appearance: cxt => {
              const name = t('default');
              const checked = preferredId === v.value;
              // const icon = tIcon( 'check', 'https://storage.googleapis.com/molten-ui-assets/check.svg' )
              return {
                name,
                checkStyle: 'checked',
                checked
              };
            },
            perform: onDefault
          });
        }
        r.push({
          handles: cxt => true,
          appearance: cxt => {
            const checkStyle = 'toggle';
            const checked = layoutId === v.value;
            // const preferred = preferredId === v.value
            // const accessoryIcon = tIcon( 'checkSmall', 'https://storage.googleapis.com/molten-ui-assets/check-small.svg' )
            const accessory = null; // preferred ? IconUtil.create( accessoryIcon ) : null
            return {
              name: v.name,
              checkStyle,
              checked,
              accessory,
              sublayout,
              sublayoutContext
            };
          },
          perform: onUse,
          layout: {
            sort: `${vgIdx}.${v.name.replaceAll('.', '_')}`,
            sectionName: showHeaders ? vg.name : null
          }
        });
      });
    });
    return r;
  }
};